import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'components/Generic/PageContent';
import { downloadProvisionalOutboundStocksForClientConditionedStock } from 'services/apiOperations';
import { useGetLatestStockModificationDate } from 'hooks';
import { AppContext } from 'context';
import { transformObjectId } from 'services/apiPlatformTransformer';
import { Period } from 'types/Period';
import { notify } from 'components/Notifier';
import ConditionedByClient from './ConditionedByClient';
import { Filter } from './types';

const ConditionedByClientPage: React.FC = () => {
  const { t } = useTranslation();
  const latestModificationOfStock = useGetLatestStockModificationDate();
  const [currentPeriod, setCurrentPeriod] = useState<Period | null>(null);
  const [exportButtonDisabled, setExportButtonDisabled] = useState<boolean>(false);
  const [filters, handleChangeFilters] = useState<Filter>({
    clientIds: [],
    materialIds: [],
    period: { startDate: null, endDate: null },
  });

  const context = useContext(AppContext);
  const sortingCenter = context.getSortingCenter?.();

  const exportConditionedStocks = () => {
    if (!currentPeriod?.startDate || !currentPeriod?.endDate || !sortingCenter) return;

    downloadProvisionalOutboundStocksForClientConditionedStock(
      transformObjectId(sortingCenter),
      currentPeriod.startDate,
      currentPeriod.endDate,
      filters?.clientIds?.[0],
      filters?.materialIds?.[0],
    ).then(() => {
      notify({
        message: t('stocks.client.exportSuccess'),
        severity: 'success',
      });
    });
  };

  return (
    <PageContent
      title={t('stocks.client.title')}
      exportButtonDisabled={exportButtonDisabled}
      exportButtonHandler={exportConditionedStocks}
    >
      <ConditionedByClient
        latestModificationOfStock={latestModificationOfStock}
        filters={filters}
        handleChangeFilters={handleChangeFilters}
        setExportButtonDisabled={setExportButtonDisabled}
        sortingCenter={sortingCenter}
        currentPeriod={currentPeriod}
        setCurrentPeriod={setCurrentPeriod}
      />
    </PageContent>
  );
};
export default ConditionedByClientPage;
